<template>
  <div class="zibo-map-page" @click="onPageClick">
    <h2>淄博市地图（点击区县查看信息）</h2>

    <div class="map-container" ref="mapRef">
      <!-- 地图图片 -->
      <img
        ref="mapImg"
        src="../../assets/img/NQR/index_bg.jpg"
        usemap="#zibo-map"
        class="zibo-map"
        alt="淄博市地图"
        width="800"
        height="600"
      >

      <!-- 你的热区（完全不变） -->
      <map name="zibo-map">
        <area 
          href="javascript:;" 
          coords="81,6,56,26,39,64,3,117,16,141,28,164,49,162,87,174,108,179,130,182,167,176,219,184,263,173,302,163,332,152,356,135,344,103,359,82,353,68,336,56,325,53,289,54,295,33,299,19,286,11,276,22,266,4,235,19,204,-1,148,36" 
          shape="poly"
          @click="showAreaInfo('高青县', '高青县：淄博北部，中国黑牛城、中国白酒名城。', $event)"
        />
        <area 
          href="javascript:;"
          coords="201,195,200,211,212,217,218,229,221,247,242,251,248,272,264,289,262,301,270,301,278,299,264,322,288,348,298,330,302,318,315,315,322,307,349,313,352,330,364,338,376,331,386,332,395,325,420,331,420,319,412,314,418,305,426,294,428,276,430,260,418,253,414,248,404,236,396,216,408,185,388,163,334,185,384,187,374,205,360,210,338,213,329,198,338,154,285,167" 
          shape="poly"
          @click="showAreaInfo('桓台县', '桓台县：淄博北部，中国建筑之乡、北方鱼米之乡。', $event)"
        />
        <area
          shape="poly"
          coords="287,348,297,330,295,318,310,312,320,305,346,312,350,327,363,335,374,328,384,330,396,322,418,327,422,342,448,354,445,378,436,393,407,388,420,400,428,416,416,419,420,428,414,435,404,437,412,459,403,475,380,481,366,473,349,481,334,469,324,465,316,475,296,448,280,437,293,409,282,412,270,409,262,394,272,385,258,375,266,360,266,333"
          href="javascript:;"
          @click="showAreaInfo('张店区', '张店区：淄博市中心城区，全市政治、经济、文化中心。', $event)"
        />
        <area
          shape="poly"
          coords="630,200, 880,220, 930,290, 880,390, 730,470, 630,390, 630,290"
          href="javascript:;"
          @click="showAreaInfo('临淄区', '临淄区：齐国故都、世界足球起源地，重要石化基地。', $event)"
        />
        <area 
          href="javascript:;"
          coords="261,327,253,334,249,346,234,346,225,353,217,350,191,357,195,370,183,393,186,404,183,415,190,418,200,425,208,447,189,452,189,441,180,456,155,491,138,491,125,493,117,495,104,505,102,529,134,529,145,521,155,522,156,502,189,502,209,487,226,480,230,499,275,489,264,458,286,442,290,410,277,412,262,396,270,392,262,379,271,364,268,338"
          shape="poly"
          @click="showAreaInfo('周村区', '周村区：“天下第一村”旱码头，鲁商文化发源地。', $event)"
        />
        <area
          shape="poly"
          coords="160,400, 700,400, 750,550, 700,670, 450,640, 350,540, 160,480"
          href="javascript:;"
          @click="showAreaInfo('淄川区', '淄川区：蒲松龄故乡，中国建材之乡、纺织名城。', $event)"
        />
        <area
          shape="poly"
          coords="160,490, 600,560, 650,700, 550,770, 350,740, 250,640,160,550"
          href="javascript:;"
          @click="showAreaInfo('博山区', '博山区：鲁菜发源地之一，中国泵业名城，琉璃陶瓷文化之乡。', $event)"
        />
        <area
          shape="poly"
          coords="350,750, 900,750, 950,900, 900,1000, 750,1050, 600,1080, 450,1050, 350,950, 300,850"
          href="javascript:;"
          @click="showAreaInfo('沂源县', '沂源县：山东屋脊，淄博市海拔最高县，牛郎织女传说发源地。', $event)"
        />
      </map>

      <div>
        <span style="white-space: break-spaces;display: flex;line-height: 1.5;text-align: left;">{{ info.briefintroduction }}</span>
      </div>

      <!-- 气泡弹窗（尖角指向点击位置） -->
      <div
        v-if="showPopup"
        class="map-bubble"
        :style="{ left: bubbleX + 'px', top: bubbleY + 'px' }"
        @click.stop
      >
        <div class="bubble-title">{{ currentName }}</div>
        <div class="bubble-desc">{{ currentDesc }}</div>
        <!-- 气泡尖角 -->
        <div class="bubble-arrow"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Server, httpurl } from '@/server';
export default {
  name: "ZiboMapClick",
  data() {
    return {
      showPopup: false,
      currentName: "",
      currentDesc: "",
      bubbleX: 0,
      bubbleY: 0,
      lastArea: null,
      info:{}
    };
  },
  mounted(){
    this.getInfo()
  },
  methods: {
    getInfo() {
      Server.getNQIQYInfo({id:'2060626619593592834'}).then(res => {
        this.info = res.result
        
      })
    },
    showAreaInfo(name, desc, e) {
      e.stopPropagation()
      this.currentName = name
      this.currentDesc = desc

      // 👇 固定图片 → 直接取图片坐标，热区永远不错位
      const img = this.$refs.mapImg
      const rect = img.getBoundingClientRect()

      // 👇 弹框永远出现在鼠标点击位置正下方
      this.popupX = e.clientX - rect.left - 100
      this.popupY = e.clientY - rect.top + 15
      this.showPopup = true

      // 高亮区域
      if (this.lastArea) {
        this.lastArea.style.background = "transparent"
      }
      e.target.style.background = "rgba(43, 125, 233, 0.3)"
      this.lastArea = e.target
    },
    // // 点击区县：高亮 + 气泡定位
    // showAreaInfo(name, desc, e) {
    //   e.stopPropagation(); // 防止冒泡到页面
    //   this.currentName = name;
    //   this.currentDesc = desc;

    //   // 气泡位置：点击位置上方
    //   const rect = this.$refs.mapRef.getBoundingClientRect();
    //   this.bubbleX = e.clientX - rect.left - 90;
    //   this.bubbleY = e.clientY - rect.top - 110;
    //   this.showPopup = true;

    //   // 区域高亮
    //   if (this.lastArea) {
    //     this.lastArea.style.background = "transparent";
    //   }
    //   e.target.style.background = "rgba(24, 144, 255, 0.4)";
    //   this.lastArea = e.target;
    // },

    // 点击空白关闭气泡 + 取消高亮
    onPageClick() {
      this.showPopup = false;
      if (this.lastArea) {
        this.lastArea.style.background = "transparent";
        this.lastArea = null;
      }
    }
  }
};
</script>

<style scoped>
.zibo-map-page {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

.map-container {
  position: relative;
  display: inline-block;
}

.zibo-map {
  /* width: 100%;
  max-width: 600px;
  border: 1px solid #eee;
  border-radius: 8px; */
  cursor: pointer;

  display: block;
  width: 800px;   /* 和上面 width 一致 */
  height: 600px;  /* 和上面 height 一致 */
  /* object-fit: cover; 不变形 */

  object-fit: contain; /* ✅ 完整显示图片，不裁切、不变形 */
}

/* 气泡弹窗样式（带尖角） */
.map-bubble {
  position: absolute;
  width: 180px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 999;
  pointer-events: none;
}

.bubble-title {
  font-weight: bold;
  color: #1890ff;
  margin-bottom: 6px;
  font-size: 14px;
}

.bubble-desc {
  font-size: 12px;
  color: #333;
  line-height: 1.5;
}

/* 气泡尖角（朝下指向点击区域） */
.bubble-arrow {
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
}
</style>